'use client';

import { c as _c } from "react/compiler-runtime";
import { ScriptProps } from 'next/script';
import { RawIntlProvider, createIntl, createIntlCache } from 'react-intl';
const intlCache = createIntlCache();
type IntlProviderProps = ScriptProps & {
  messages: Record<string, any>;
  locale: string;
};
export const IntlProvider = t0 => {
  const $ = _c(6);
  const {
    children,
    messages,
    locale
  } = t0;
  let t1;
  if ($[0] !== locale || $[1] !== messages) {
    t1 = createIntl({
      locale,
      messages,
      formats: {
        number: {
          CS: {
            style: "currency",
            currency: "CZK"
          },
          EN: {
            style: "currency",
            currency: "US"
          }
        }
      }
    }, intlCache);
    $[0] = locale;
    $[1] = messages;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = t1;
  let t2;
  if ($[3] !== children || $[4] !== intl) {
    t2 = <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
    $[3] = children;
    $[4] = intl;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};